if (!window.webshop) window.webshop = {}
if (!dontmanage.boot) dontmanage.boot = {}
